import React from "react";
import { Helmet } from "react-helmet";
// import img1 from "../../../assets/islam/img-title/กฎหมายมรดก.png";
import "./posts-islam.css";

const ทายาทอิส = () => {
  const TITLE = "กฎหมายมรดกอิสลาม";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <br></br>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ทายาท</b> หมายถึง
          บุคคลที่มีสิทธิรับมรดกของผู้ตาย แต่ไม่รวมถึงผู้รับพินัยกรรม
          โดยผู้ที่เป็นทายาทของผู้ตายจะต้องมีคุณสมบัติที่ถูกกำหนดไว้
        </p>

        {/* 1. ทายาทที่มีสิทธิรับมรดก */}
        <div>
          <h2 id="initial-header">1. ทายาทที่มีสิทธิรับมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ทายาทที่มีสิทธิรับมรดกในกฎหมายอิสลาม ถูกแบ่งออกเป็น 2 กลุ่ม คือ
            ทายาทฝ่ายชาย และทายาทฝ่ายหญิง
            โดยในแต่ละกลุ่มมีทายาทดังรายชื่อต่อไปนี้
            <ul className=" list-disc ml-16 mt-3">
              <li>
                <b>ทายาทฝ่ายชายที่มีสิทธิรับมรดกมี 15 คน</b>
                <ul className=" list-decimal ml-8 mb-3">
                  <li>บุตรชาย</li>
                  <li>หลานชาย (บุตรของบุตรชาย)</li>
                  <li>บิดา</li>
                  <li>ปู่ที่ถูกต้องตามกฎหมายมรดก</li>
                  <li>พี่ชาย หรือน้องชายร่วมบิดามารดา</li>
                  <li>พี่ชาย หรือน้องชายร่วมแต่บิดา</li>
                  <li>พี่ชาย หรือน้องชายร่วมแต่มารดา</li>
                  <li>บุตรชายของพี่น้องร่วมบิดามารดา</li>
                  <li>บุตรชายของพี่น้องร่วมแต่บิดา</li>
                  <li>พี่ชาย หรือน้องชายของบิดาที่ร่วมแต่มารดา</li>
                  <li>พี่ชาย หรือน้องชายของบิดาที่ร่วมแต่บิดา</li>
                  <li>บุตรชายของพี่ชาย หรือน้องชายของบิดาที่ร่วมบิดามารดา</li>
                  <li>บุตรชายของพี่ชาย หรือน้องชายของบิดาที่ร่วมแต่บิดา</li>
                  <li>สามี</li>
                  <li>นายที่ปล่อยทาสให้เป็นไท</li>
                </ul>
              </li>

              <li>
                <b>ทายาทฝ่ายหญิงที่มีสิทธิรับมรดกมี 10 คน</b>
                <ul className=" list-decimal ml-8 mb-3">
                  <li>บุตรสาว</li>
                  <li>หลานสาว (บุตรสาวของบุตรชาย)</li>
                  <li>มารดา</li>
                  <li>ยายที่ถูกต้องตามกฎหมายมรดก (มารดาของมารดา)</li>
                  <li>ย่าที่ถูกต้องตามกฎหมายมรดก (มารดาของบิดา)</li>
                  <li>พี่สาว หรือน้องสาวร่วมบิดามารดา</li>
                  <li>พี่สาว หรือน้องสาวร่วมแต่บิดา</li>
                  <li>พี่สาว หรือน้องสาวร่วมแต่มารดา</li>
                  <li>ภรรยา</li>
                  <li>นายสาวที่ปล่อยทาส</li>
                </ul>
              </li>
            </ul>
          </p>
        </div>

        {/* 2. คุณสมบัติของผู้ที่เป็นทายาท */}
        <div>
          <h2 id="second-header">2. คุณสมบัติของผู้ที่เป็นทายาท</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ทายาทที่มีสิทธิรับมรดกจะต้องมีคุณสมบัติดังต่อไปนี้
            <ul className=" list-decimal ml-16 mt-3">
              <li>
                <b>ต้องเป็นญาติหรือคู่สมรส</b>{" "}
                ที่ถูกต้องตามหลักกฎหมายอิสลามของผู้ตายเท่านั้น
                <ul className=" list-disc ml-8 mb-3">
                  <li>
                    ญาติที่ไม่มีสิทธิได้รับมรดก
                    <span className=" text-blue-600">
                    &nbsp;-- เช่น
                    การสมรสระหว่างบิดาและมารดาของบุตรไม่ถูกต้องตามหลักอิสลาม
                    </span> 
                    &nbsp;จะไม่ถือว่าบิดากับบุตรเป็นทายาทซึ่งกันและกัน
                  </li>
                  <li>
                    คู่สมรสที่ไม่มีสิทธิได้รับมรดก 
                    <span className=" text-blue-600">
                    &nbsp; -- เช่น สามีกับภรรยาเมื่อปรากฏว่าการสมรสระหว่างทั้งสองนั้นไม่ถูกต้องตามหลักอิสลาม 
                    </span>
                  </li>
                </ul>
              </li>

              <li>
                <b>ต้องนับถืออิสลามเหมือนกับเจ้ามรดก</b> หากผู้ตาย (เจ้ามรดก)
                นับถืออิสลาม
                ทายาทที่มีสิทธิรับมรดกจำเป็นต้องนับถือศาสนาอิสลามเช่นเดียวกับเจ้ามรดก
              </li>

              <li>
                <b>จะต้องไม่เป็นผู้ที่ฆ่าเจ้ามรดก</b>{" "}
                ไม่ว่าด้วยเจตนาหรือประมาทอย่างร้ายแรง
              </li>

              <li>
                <b>จะต้องมีสภาพเป็นบุคคลขณะที่เจ้ามรดกถึงแก่ความตาย</b>{" "}
                ทายาทที่ถึงแก่ความตายก่อนหรือพร้อมกันกับเจ้ามรดกถึงแก่ความตาย
                ทายาทผู้นั้นจะไม่มีสิทธิรับมดกของเจ้ามรดก{" "}
                <mark className=" bg-[#fee9b2] rounded-xl">
                  เว้นแต่ทายาทที่ป็นทารกในครรภ์มารดา
                  ถึงแม้จะยังไม่มีสภาพเป็นบุคคลโดยสมบูรณ์
                </mark>{" "}
              </li>

              <li>
                <b>จะต้องไม่ถูกกันสิทธิ</b>ในการรับมรดกโดยผู้หนึ่งผู้ใด
              </li>
            </ul>
          </p>
        </div>

        {/* 3. ประเภทของทายาท*/}
        <div>
          <h2 id="third-header">3. ประเภทของทายาท</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อาริฟ คอลีล อาบูอีด
            ได้แบ่งทายาทที่มีสิทธิได้รับมรดกออกเป็น 4 ประเภทคือ
          </p>

          {/* 3.1  อัศฮาบุลฟุรูฎ*/}
          <div>
            {/* เกริ่น */}
            <div>
              <h3 id="fourth-header">
                3.1 อัศฮาบุลฟุรูฎ (الصحاب الفروض)
              </h3>
              <p className="ml-8">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง
                ทายาทที่ได้ถูกกำหนดสัดส่วนของสิทธิอย่างชัดเจนในอัลกรุอ่าน
                อัสสุนนะฮฺ หรือ อิจญ์มาอฺ โดยทายาทประเภทอัศฮาบุลฟุรูฎ (الصحاب
                الفروض) ถูกแบ่งออกเป็น 2 กลุ่ม ดังนี้
                <ul className=" list-disc ml-16 mt-3">
                  <li>
                    <b>อัศฮาบุลฟูรูฎ อันนะสะบียะห์ (اصحاب الفروض النسبية) </b>{" "}
                    คือ
                    กลุ่มทายาทที่มีสิทธิในการรับมรดกแบบอัตราส่วนที่ถูกกำหนดส่วนที่กำหนดไว้ในอัลกุรอ่าน
                    อัสสุนนะฮฺ หรือ อิจญ์มาอฺ
                    <mark className=" bg-[#fee9b2] rounded-xl">
                      เนื่องจากมีความใกล้ชิดทางสายเลือดกับผู้ตาย (เจ้ามรดก)
                    </mark>{" "}
                    <p className="ml-8">
                    <span className=" text-blue-600">
                        &nbsp; 
                        -- เช่น บิดามารดาของผู้ตาย บุตรสาวของผู้ตาย
                        หรืออาจเป็นพี่หรือน้องสาวร่วมบิดามารดากับผู้ตาย เป็นต้น
                      </span>
                    </p>
                  </li>

                  <li>
                    <b>อัศฮาบุลฟูรูฎ อัสสะบาบียะห์ (اصحاب الفروض السببية) </b>{" "}
                    คือ กลุ่มทายาทที่มีสิทธิในการรับมรดก{" "}
                    <mark className=" bg-[#fee9b2] rounded-xl">
                      เนื่องจากมีการสมรสระหว่างกัน หรือก็คือสามีภรรยา
                    </mark>{" "}
                    ซึ่งถูกกำหนดไว้ในอัลกุรอ่าน อัสสุนนะฮฺ หรือ อิจญ์มาอฺ
                  </li>
                </ul>
                <br></br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                ซึ่งทายาทประเภทที่ 1. อัศฮาบุลฟุรูฎ (الصحاب الفروض)
                เป็นทายาทประเภทที่มีสิทธิรับส่วนกำหนดตามที่กำหนดไว้{" "}
                <mark className=" bg-[#fee9b2] rounded-xl">
                  ถูกแบ่งออกเป็น 11 รายดังต่อไปนี้
                </mark>
              </p>
            </div>

            {/* 3.1.1 สามี */}
            <div>
              <h4 id="fifth-header">3.1.1 สามี</h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 2 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3" >
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>
                      <a>
                        ได้รับ 1/2 ของกองมรดก หากเจ้ามรดก (ผู้ตาย)
                        ไม่มีผู้สืบสันดานสายชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        สามีจะได้รับมรดก 1/2 ของกองมรดก
                        หากผู้ตายที่เป็นภรรยาไม่มีบุตร ไ่ม่ว่าจะเป็นบุตรชาย
                        หรือบุตรสาว และไม่มีหลานชาย หรือหลานสาว
                        (ต้องเป็นหลานสาวที่เกิดจากบุตรชายเท่านั้น)
                        โดยไม่คำนึงว่าจะเป็นบุตรที่เกิดจากสามีปัจจุบัน
                        หรือสามีอื่น และแม้แต่จะเป็นบุตรนอกสมรส (บุตรซีนา)
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/4 ของกองมรดก หากเจ้ามรดก (ผู้ตาย)
                        มีผู้สืบสันดานสายชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        สามีมีสิทธิที่จะได้รับมรดก 1/4 ของกองมรดก
                        หากผู้ตายที่เป็นภรรยามีผู้สืบสันดาน
                        โดยไม่คำนึงถึงว่าจะเป็นบุตรที่เกิดจากสามีปัจจุบันหรือจากอดีตสามี
                        และไม่คำนึงว่าบุตร หรือหลานจะเป็นเพศชาย หรือเพศหญิง
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.2 ภรรยา */}
            <div>
              <h4 id="sixth-header">3.1.2. ภรรยา</h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 2 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>
                  {/* ลำดับที่ 2.1.1. ภรรยา*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>
                        ได้รับ 1/4 ของกองมรดก หากเจ้ามรดก (ผู้ตาย)
                        ไม่มีผู้สืบสันดานสายชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        ภรรยาหนึ่งคนหรือหลายคนจะได้รับจะได้รับมรดก 1/4
                        เมื่อสามีหรือผู้ตายไม่มีบุตร หรือหลานที่เกิดจากบุตรชาย
                        ไม่ว่าจะเป็นบุตรที่เกิดจากภรรยาปัจจุบัน
                        หรือเกิดจากอดีตภรรยาก็ตาม
                        และไม่คำนึงว่าบุตรหรือหลานนั้นจะเป็นหญิง หรือชาย
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/8 ของกองมรดก หากเจ้ามรดก (ผู้ตาย) มีบุตร
                        หรือผู้สืบสันดานสายชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        ภรรยาของผู้ตายมีสิทธิได้รับมรดก 1/8
                        โดยมีเงื่อนไขว่าหากสามีที่เป็นผู้ตายมีบุตรหรือหลาน
                        โดยไม่คำนึงว่าจะเกิดจากภรรยาคนปัจจุบัน
                        หรือเกิดจากภรรยาคนอื่น ๆ ของสามี และไม่คำนึงว่าบุตร
                        หรือหลานนั้นจะเป็นเพศชาย หรือเพศหญิง
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.3 บิดา */}
            <div>
              <h4 id="seventh-header">3.1.3. บิดา</h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 3 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดก หากเจ้ามรดก (ผู้ตาย) มีบุตรชาย
                        หรือผู้สืบสันดานสายชายที่เป็นเพศชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        บิดาของผู้ตาย (บุตรชาย หรือบุตรสาว)
                        จะได้รับมรดกของผู้ตาย 1/6
                        โดยมีเงื่อนไขว่าหากผู้ตายมีบุตรชาย
                        หรือผู้สืบสันดานสายชายที่เป็นเพศชาย (หลานชาย, เหลนชาย
                        ฯลฯ)
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดก และส่วนเหลือ หากเจ้ามรดก (ผู้ตาย)
                        มีบุตรสาว หรือผู้สืบสันดานสายชายที่เป็นเพศหญิง
                      </a>
                    </td>
                    <td>
                      <a>
                        บิดาของผู้ตาย (บุตรชาย หรือบุตรสาว)
                        จะได้รับมรดกของผู้ตาย 1/6 และส่วนเหลือ
                        โดยมีเงื่อนไขว่าหากผู้ตายมีบุตรสาว
                        หรือผู้สืบสันดานสายชายที่เป็นเพศหญิง (หลานสาว, เหลนสาว)
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>
                        ได้รับส่วนเหลือ หากเจ้ามรดก (ผู้ตาย)
                        ไม่มีผู้สืบสันดานสายชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        บิดาของผู้ตาย (บุตรชาย หรือบุตรสาว) จะได้รับส่วนเหลือ
                        โดยมีเงื่อนไขว่าหากผู้ตายไม่มีบุตร ไม่ว่าจะเป็นชาย
                        หรือหญิง, หลานชาย หรือหลานสาวอันเกิดจากบุตรชายของผู้ตาย
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.4  มารดา */}
            <div>
              <h4 id="eigth-header">3.1.4. มารดา</h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 3 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดก หากเจ้ามรดก (ผู้ตาย)
                        มีผู้สืบสันดานสายชายหรือมีพี่น้องหลายคน
                      </a>
                    </td>
                    <td>
                      <a>
                        มารดาของผู้ตาย (บุตรชาย หรือบุตรสาว)
                        จะได้รับมรดกของผู้ตาย 1/6 เมื่อผู้ตายมีบุตร หรือมีหลาน
                        (บุตรของบุตรชายของผู้ตาย) หรือมีทายาทที่มาจากสายชาย
                        หรือผู้ตายมีพี่น้องตั้งแต่ 2 คนขึ้นไป (พี่น้องชาย
                        หรือหญิง) จะร่วมบิดามราดา หรือร่วมแต่บิดา
                        หรือร่วมแต่มารดาก็ตาม
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>ได้รับ 1/3 ของกองมรดก</a>
                    </td>
                    <td>
                      <a>
                        มารดาของผู้ตาย (บุตรชาย หรือบุตรสาว)
                        จะได้รับมรดกของผู้ตาย 1/3 ถ้าหากผู้ตายไม่มีบุตร,
                        ผู้สืบสันดานสายชาย, ไม่มีพี่น้อง (หญิง หรือชาย)
                        หรือมีแต่ต้องไม่เกิน 1 คน
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>ได้รับ 1/3 จากส่วนที่เหลือ</a>
                    </td>
                    <td>
                      <a>
                        มารดาของผู้ตาย (บุตรชาย หรือบุตรสาว)
                        จะได้รับมรดกของผู้ตาย 1/3 จากส่วนที่เหลือ
                        ในกรณีที่ผู้ตาย (บุตรสาว) มีแต่สามีและบิดา หรือผู้ตาย
                        (บุตรชาย) มีภรรยาและบิดาร่วมอยู่ด้วย
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.5 ปู่ */}
            <div>
              <h4 id="ninth-header">3.1.5. ปู่</h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 6 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>ถูกกันสิทธิ หากเจ้ามรดก (ผู้ตาย) มีบิดา</a>
                    </td>
                    <td>
                      <a>
                        ปู่ของผู้ตายจะไม่มีสิทธิรับมรดก
                        ถ้ามีบิดาของของผู้ตายร่วมอยู่ด้วย
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีบุตรชาย
                        หรือผู้สืบสันดานสายชายที่เป็นเพศชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        ปู่ของผู้ตาย จะได้รับมรดกของผู้ตาย 1/6
                        ในกรณีที่ผู้ตายมีบุตรชาย
                        หรือผู้สืบสันดานสายชายที่เป็นเพศชาย (บุตรชาย
                        หรือหลานชายอันเกิดจากผู้ตายที่เป็นบุตรชาย เช่น หลานชาย,
                        เหลนชาย)
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 3*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>
                        ได้รับ 1/6 และส่วนที่เหลือ หากเจ้ามรดก (ผู้ตาย)
                        มีบุตรสาว หรือผู้สืบสันดานสายชายที่เป็นเพศหญิง
                      </a>
                    </td>
                    <td>
                      <a>
                        ปู่ของผู้ตาย จะได้รับมรดกของผู้ตาย 1/6
                        และส่วนที่เหลือในกรณีที่ผู้ตายมีบุตรสาว
                        หรือผู้สืบสันดานสายชายที่เป็นเพศหญิง (บุตรสาว
                        หรือหลานสาวอันเกิดจากผู้ตายที่เป็นบุตรชาย เช่น หลานสาว,
                        เหลนสาว)
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 3*/}
                  {/* ลำดับที่ 4*/}
                  <tr>
                    <td>4</td>
                    <td>
                      <a>
                        ได้รับส่วนที่เหลือ หากเจ้ามรดก (ผู้ตาย)
                        หากเจ้ามรดกไม่มีผู้สืบสันดานสายชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        ปู่ของผู้ตายจะได้รับมรดกเป็นส่วเหลือ
                        ในกรณีที่ผู้ตายไม่มีบุตรชาย หรือบุตรสาว หรือหลานชาย
                        หรือหลานสาวอันเกิดจากบุตรชายของผู้ตาย
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.6 ย่า และยาย */}
            <div>
              <h4 id="tenth-header">3.1.6. ย่า และยาย</h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 2 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>ถูกกันสิทธิ หากเจ้ามรดก (ผู้ตาย) มีบิดามารดา</a>
                    </td>
                    <td>
                      <a>
                        -ยายของผู้ตายจะถูกกันสิทธิในกรณีที่ผู้ตายมีมารดา
                        <br></br>
                        -ย่าของผู้ตายจะถูกกันสิทธิในกรณีที่ผู้ตายมีบิดา
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>ได้รับ 1/6 ของกองมรดก</a>
                    </td>
                    <td>
                      <a>
                        ย่าและยาย จะได้รับ 1/6
                        ของกองมรดกหากไม่มีผู้กันสิทธิดังที่ได้กล่าวในสภาพที่ 1
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.7 บุตรสาว */}
            <div>
              <h4 id="eleventh-header">3.1.7. บุตรสาว</h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 3 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>
                        ได้รับ 1/2 ของกองมรดกหากว่ามีบุตรสาวเพียงคนเดียว
                        และไม่มีบุตรชาย
                      </a>
                    </td>
                    <td>
                      <a>
                        บุตรสาวของผู้ตายจะได้รับ 1/2 ของกองมรดก
                        ในกรณีที่ผู้ตายมีบุตรสาวเพียงคนเดียว
                        และผู้ตายไม่มีบุตรชาย
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 2/3 ของกองมรดกหากเจ้ามรดก (ผู้ตาย)
                        มีบุตรสาวหลายคน
                      </a>
                    </td>
                    <td>
                      <a>
                        บุตรสาวของผู้ตาย จะได้รับ 2/3
                        ของกองมรดกในกรณีที่ผู้ตายมีบุตรสาว
                        (พี่สาวหรือน้องสาวของบุตรสาว) ตั้งแต่ 2 คนขึ้นไป
                        โดยจะต้องไม่มีบุตรชาย (พี่ชายหรือน้องชายของบุตรสาว)
                        ร่วมอยู่ด้วย
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 3*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>
                        ร่วมกันรับส่วนที่เหลือกับบุตรชาย หากเจ้ามรดก (ผู้ตาย)
                        มีบุตรชายร่วมอยู่ด้วย
                      </a>
                    </td>
                    <td>
                      <a>
                        บุตรสาวของผู้ตายจะได้รับส่วนที่เหลือ
                        ในกรณีที่ผู้ตายมีบุตรชาย (พี่ชายหรือน้องชายของบุตรสาว)
                        ร่วมอยู่ด้วย โดยให้แบ่งให้บุตรชาย 2 ส่วน บุตรสาว 1 ส่วน
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.8 หลานสาวที่เกิดจากบุตรชายของผู้ตาย */}
            <div>
              <h4 id="twelfth-header">
                3.1.8. หลานสาว{" "}
                <mark className=" bg-[#fee9b2] rounded-xl">
                  (อันเกิดจากบุตรชายของผู้ตาย){" "}
                </mark>{" "}
              </h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 5 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>ถูกกันสิทธิ</a>
                    </td>
                    <td>
                      <a>
                        หลานสาวจะถูกกันสิทธิ หากผู้ตายมีบุตรชาย
                        หรือมีบุตรสาวตั้งแต่ 2 คนขึ้นไป
                        และผู้ตายไม่มีผู้สืบสันดานสายชายที่เป็นเพศชาย
                        ที่ได้รับส่วนที่เหลือร่วมกับนางในกรณีที่หลานสาวอันเกิดจากบุตรชายได้รับครึ่งหนึ่งจากกองมรดกนั้น
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/2 ของกองมรดกหากเจ้ามรดก (ผู้ตาย)
                        มีหลานสาวเพียงคนเดียว
                      </a>
                    </td>
                    <td>
                      <a>
                        หลานสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 1/2
                        ในกรณีที่ผู้ตายมีหลานสาวเพียงคนเดียว
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 3*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>
                        ได้รับ 2/3 ของกองมรดกหากเจ้ามรดก (ผู้ตาย)
                        มีหลานสาวหลายคน
                      </a>
                    </td>
                    <td>
                      <a>
                        หลานสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 2/3
                        ในกรณีที่ผู้ตายมีหลานสาวหลายคน
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 3*/}
                  {/* ลำดับที่ 4*/}
                  <tr>
                    <td>4</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดกหากเจ้ามรดก (ผู้ตาย)
                        มีบุตรสาวร่วมอยู่ด้วย 1 คน
                      </a>
                    </td>
                    <td>
                      <a>
                        หลานสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 1/6
                        ในกรณีที่ผู้ตายมีบุตรสาวร่วมอยู่ด้วย 1 คน
                        และไม่มีผู้สืบสันดานสายชายที่เป็นเพศชายที่อยู่ระดับเดียวกัน
                        โดยบุตรสาวของผู้ตายได้ครึ่งหนึ่งตามอัตราส่วนที่ถูกกำหนด
                        และหลานสาวนั้นได้ 1/6
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 4*/}
                  {/* ลำดับที่ 5*/}
                  <tr>
                    <td>5</td>
                    <td>
                      <a>ได้รับส่วนที่เหลือ</a>
                    </td>
                    <td>
                      <a>
                        หลานสาวของผู้ตาย จะได้รับส่วนที่เหลือของกองมรดก
                        ในกรณีที่มีพี่ชาย หรือน้องชาย
                        หรือลูกพี่น้องชายร่วมอยู่ด้วย
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.9 พี่สาว หรือน้องสาวร่วมบิดามารดา */}
            <div>
              <h4 id="thirteenth-header">
                3.1.9. พี่สาว หรือน้องสาว
                <mark className=" bg-[#fee9b2] rounded-xl">ร่วมบิดามารดา</mark>
              </h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 5 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>ถูกกันสิทธิ</a>
                    </td>
                    <td>
                      <a>
                        ถูกกันสิทธิโดย
                        <br></br>-บุตรชาย
                        <br></br>-ผู้สืบสันดานสายชายที่เป็นเพศชาย
                        <br></br>-บิดา
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/2 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีพี่สาว
                        หรือน้องสาวเพียงคนเดียว
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 1/2
                        ในกรณีที่ผู้ตายมีพี่น้องที่เป็นเพศหญิงเพียงคนเดียว
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 3*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>
                        ได้รับ 2/3 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีพี่สาว
                        หรือน้องสาวหลายคน
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 2/3
                        ในกรณีที่ผู้ตายมีพี่น้องที่เป็นเพศหญิงหลายคนร่วมอยู่ด้วย
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 3*/}
                  {/* ลำดับที่ 4*/}
                  <tr>
                    <td>4</td>
                    <td>
                      <a>
                        ร่วมกันรับส่วนที่เหลือกับพี่ชาย หรือน้องชายร่วมบิดามารดา
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย
                        จะได้รับมรดกของผู้ตายเป็นส่วนเหลือ ร่วมกับพี่ชาย
                        หรือน้องชายร่วมบิดามารดาเดียวกัน โดยแบ่งให้ฝ่ายชาย 2
                        ส่วนต่อฝ่ายหญิง 1 ส่วน
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 4*/}
                  {/* ลำดับที่ 5*/}
                  <tr>
                    <td>5</td>
                    <td>
                      <a>ได้รับส่วนที่เหลือ</a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย
                        จะได้รับมรดกของผู้ตายเป็นส่วนเหลือ ถ้าผู้ตายมีบุตรสาว
                        หรือผู้สืบสันดานสายชายที่เป็นเพศหญิง
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.10 พี่สาว หรือน้องสาวร่วมแต่บิดา */}
            <div>
              <h4 id="fourteenth-header">
                3.1.10. พี่สาว หรือน้องสาว
                <mark className=" bg-[#fee9b2] rounded-xl">ร่วมแต่บิดา</mark>
              </h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 6 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>ถูกกันสิทธิ</a>
                    </td>
                    <td>
                      <a>
                        ถูกกันสิทธิโดย
                        <br></br>-บิดา
                        <br></br>-บุตรชาย หรือผู้สืบสันดานสายชายที่เป็นเพศชาย
                        <br></br>-พี่น้องชายร่วมบิดามารดา
                        <br></br>-พี่สาว หรือน้องสาวร่วมบิดามารดาของผู้ตาย 2
                        คนขึ้นไป แต่ถ้ามีพี่ชายร่วมอยู่ด้วย ก็ได้รับส่วนเหลือ
                        <br></br>-พี่สาว
                        หรือน้องสาวร่วมบิดามารดาของผู้ตายที่อยู่ในสภาพที่รับส่วนเหลือ
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/2 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีพี่สาว
                        หรือน้องสาวเพียงคนเดียว
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 1/2
                        ในกรณีที่ผู้ตายมีพี่น้องที่เป็นเพศหญิงเพียงคนเดียว
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 3*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>
                        ได้รับ 2/3 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีพี่สาว
                        หรือน้องสาวหลายคน
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 2/3
                        ในกรณีที่ผู้ตายมีพี่น้องที่เป็นเพศหญิงหลายคนร่วมอยู่ด้วย
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 3*/}
                  {/* ลำดับที่ 4*/}
                  <tr>
                    <td>4</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีพี่สาว
                        หรือน้องสาวร่วมบิดามารดา 1 คน
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 1/6
                        ในกรณีที่ผู้ตายมีพี่สาว หรือน้องสาวร่วมบิดามารดา
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 4*/}
                  {/* ลำดับที่ 5*/}
                  <tr>
                    <td>5</td>
                    <td>
                      <a>
                        ร่วมกันรับส่วนที่เหลือกับพี่ชาย หรือน้องชายร่วมแต่บิดา
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย
                        จะได้รับมรดกของผู้ตายเป็นส่วนเหลือ ร่วมกับพี่ชาย
                        หรือน้องชายร่วมแต่บิดาเดียวกัน โดยแบ่งให้ฝ่ายชาย 2
                        ส่วนต่อฝ่ายหญิง 1 ส่วน
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 5*/}
                  {/* ลำดับที่ 6*/}
                  <tr>
                    <td>5</td>
                    <td>
                      <a>ได้รับส่วนที่เหลือ</a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย
                        จะได้รับมรดกของผู้ตายเป็นส่วนเหลือ ถ้าผู้ตายมีบุตรสาว
                        หรือผู้สืบสันดานสายชายที่เป็นเพศหญิง
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            {/* 3.1.11 พี่ หรือน้องร่วมแต่มารดา */}
            <div>
              <h4 id="fifteenth-header">
                3.1.11. พี่ หรือน้อง
                <mark className=" bg-[#fee9b2] rounded-xl">ร่วมแต่มารดา</mark>
              </h4>
              <p className="ml-16">
                มีสิทธิรับมรดก 4 สภาพด้วยกัน ดังตารางต่อไปนี้
                <table className=" w-full mt-3">
                  {/* หัวข้อ */}
                  <tr>
                    <th>สภาพ</th>
                    <th>เงื่อนไข</th>
                    <th>คำอธิบาย</th>
                  </tr>{" "}
                  {/* จบหัวข้อ */}
                  {/* ลำดับที่ 1*/}
                  <tr>
                    <td>1</td>
                    <td>
                      <a>ถูกกันสิทธิ</a>
                    </td>
                    <td>
                      <a>
                        ถูกกันสิทธิโดย
                        <br></br>-บุตรชาย หรือผู้สืบสันดานสายชาย
                        <br></br>-บิดา หรือปู่
                        หรือผู้ที่อยู่ในลำดับที่สูงขึ้นไปจนสุดสาย
                      </a>
                    </td>
                  </tr>{" "}
                  {/*จบลำดับที่ 1 */}
                  {/* ลำดับที่ 2*/}
                  <tr>
                    <td>2</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีพี่
                        หรือน้องเพียง (ไม่ว่าจะเป็นชาย หรือหญิง) คนเดียว
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่หรือน้อง (ไม่ว่าจะเป็นชาย หรือหญิง) ของผู้ตาย
                        จะได้รับมรดกของผู้ตาย 1/6
                        ในกรณีที่ผู้ตายมีพี่น้องไม่ว่าชาย หรือหญิงเพียงคนเดียว
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 2*/}
                  {/* ลำดับที่ 3*/}
                  <tr>
                    <td>3</td>
                    <td>
                      <a>
                        ได้รับ 1/6 ของกองมรดกหากเจ้ามรดก (ผู้ตาย) มีพี่
                        หรือน้องเพียง (ไม่ว่าจะเป็นชาย หรือหญิง) หลายคน
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่หรือน้อง (ไม่ว่าจะเป็นชาย หรือหญิง) ของผู้ตาย
                        จะได้รับมรดกของผู้ตาย 1/6
                        ในกรณีที่ผู้ตายมีพี่น้องไม่ว่าชาย
                        หรือหญิงหลายคนร่วมอยู่ด้วย
                      </a>
                    </td>
                  </tr>{" "}
                  {/* จบลำดับที่ 3*/}
                  {/* ลำดับที่ 4*/}
                  <tr>
                    <td>4</td>
                    <td>
                      <a>
                        ได้รับ 1/3 ของกองมรดกหากเจ้ามรดก (ผู้ตาย)
                        มีพี่น้องร่วมบิดามารดา
                      </a>
                    </td>
                    <td>
                      <a>
                        พี่สาวหรือน้องสาวของผู้ตาย จะได้รับมรดกของผู้ตาย 1/3
                        ในกรณีที่พี่น้องร่วมบิดามารดามีสิทธิรับส่วนที่เหลือ
                      </a>
                    </td>
                  </tr> {/* จบลำดับที่ 4*/}
                </table> {/*จบตาราง 3.1.11 พี่ หรือน้องร่วมแต่มารดา */}
              </p>
            </div>
            
            {/* 3.2 อัลอะเศาะบะฮฺ อันนะสะบียะห์ */}
            <div>
              <br></br>
              <h3 id="sixteenth-header">3.2 อัลอะเศาะบะฮฺ อันนะสะบียะห์ (العصبة النسبية)</h3>
              <p className="ml-8">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง กลุ่มทายาทฝ่ายชายที่มีสิทธิในการรับมรดกแบบส่วนเหลือ เนื่องจากมีความใกล้ชิดกับผู้ตายทางด้านบิดาของเขา
                โดยที่ไม่มีผู้หญิงเข้ามาแทรกระหว่างพวกเขากับเจ้ามรดก (ผู้ตาย) เลย หรือหมายถึง <mark className=" bg-[#fee9b2] rounded-xl">ทายาทที่มาจากเชื้อสายและเครือญาติฝ่ายบิดาของผู้ตาย พวกเขามีสิทธิได้รับมรดกในส่วนที่เหลือ</mark>{" "}
                  <br></br>
                  <p className="ml-8">
                    <span className=" text-blue-600">
                    -- เช่น  บุตรชาย หลานชาย (บุตรของบุตรชายของผู้ตาย) บิดา อา และน้องสาวของผู้ตายในกรณีที่มีพร้อมกับบุตรสาวของผู้ตาย
                    </span>
                  </p>
                ซึ่งทายาทผู้รับส่วนเหลือ หรือภาคอะเศาะบะฮฺภาคนี้มี 3 ประเภทดังนี้
                  <ul className=" list-decimal ml-16 mt-3">
                    <li> <b>ผู้รับส่วนเหลือโดยตัวเขาเอง (العصبة بالنفس)</b> <br></br> 
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง เครือญาติฝ่ายชายที่มีความใกล้ชิดกับผู้ตายโดยตรงโดยที่ไม่มีผ่ายหญิงมากั้นกลางระหว่างเขากับผู้ตาย ซึ่งมีอยู่ 4 ประเภทด้วยกัน 
                      <ul className=" list-disc ml-16 mt-3">
                        <li>ก. ทายาทของผู้ตายด้านบุตร
                          <p className="ml-8">
                            <span className=" text-blue-600">
                            -- เช่น  บุตรชาย หลานชาย (บุตรของบุตรชายของผู้ตาย) เหลนชาย หรือผู้สืบสันดานสายชายที่เป็นเพศชาย
                            </span>
                          </p>
                        </li>
                        <li>ข. ต้นตระกูลของผู้ตาย หรือทายาททางด้านฝ่ายบิดา
                          <p className="ml-8">
                              <span className=" text-blue-600">
                              -- เช่น  บิดา ปู่ หรือผู้ที่อยู่ในลำดับที่สูงขึ้นไปจนสุดสาย
                              </span>
                          </p>                         
                        </li>
                        <li>ค. ทายาทของผู้ตายจากฝ่ายบิดาของผู้ตาย
                          <p className="ml-8">
                              <span className=" text-blue-600">
                              -- เช่น  พี่ชาย หรือน้องชายร่วมบิดามารดากับผู้ตาย หรือร่วมแต่บิดากับผู้ตาย และบรรดาบุตรของเขาถึงแม้จะต่ำไปจนสุดสาย
                              </span>
                          </p>                          
                        </li>
                        <li>ง. ทายาทของปู่ของผู้ตาย และบรรดาบุตรของพวกเขา
                          <p className="ml-8">
                              <span className=" text-blue-600">
                              -- เช่น ลุง อา และบุตรของลุง หรือบุตรของอา
                              </span>
                          </p>                          
                        </li>
                      </ul>
                      <b>ซึ่งทายาททั้ง 4 ประเภทนี้สามารถเรียงลำดับได้ดังนี้</b>
                      <ul className=" list-decimal ml-16 mt-3">
                          <li>บุตรชาย หรือหลานชาย หรือเหลนชาย หรือชายที่มีตำแหน่งที่ต่ำลงไปเรื่อย ๆ</li>
                          <li>บิดา</li>
                          <li>ปู่</li>
                          <li>พี่ชาย หรือน้องชายร่วมบิดามารดา</li>
                          <li>พี่ชาย หรือน้องชายร่วมแต่บิดา</li>
                          <li>บุตรชายของข้อที่ 4</li>
                          <li>บุตรชายของข้อที่ 5</li>
                          <li>บุตรชายของข้อที่ 6</li>
                          <li>บุตรชายของข้อที่ 7</li>
                          <li>ชายที่มีตำแหน่งต่ำลงไปจากลำดับที่ 6 และ 7 โดยสลับกัน</li>
                          <li>พี่ชาย หรือน้องชายของบิดาร่วมบิดามารดา</li>
                          <li>พี่ชาย หรือน้องชายของบิดาร่วมแต่บิดา</li>
                          <li>บุตรชายของข้อที่ 11</li>
                          <li>บุตรชายของข้อที่ 12</li>
                          <li>ชายที่มีตำแหน่งต่ำลงไปจากลำดับที่ 11 และ 12 โดยสลับกัน</li>
                          <li>พี่ชาย หรือน้องชายของปู่ร่วมบิดามารดา</li>
                          <li>พี่ชาย หรือน้องชายของปู่ร่วมแต่บิดา</li>
                          <li>บุตรชายของลำดับที่ 16</li>
                          <li>บุตรชายของลำดับที่ 17</li>
                          <li>ผู้ชายที่มีตำแหน่งที่ต่ำลงไปจากลำดับที่ 16 และ 17</li>
                      </ul>
                    </li>
                    <li>
                      <b>ผู้รับส่วนเหลือโดยอาศัยผู้อื่น (العصبة بالغير)</b> <br></br>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง ทายาทฝ่ายผู้หญิงที่มีส่วนกำหนดแน่นอนอยู่แล้ว แต่หากพวกเขาอยู่พร้อมกับผู้รับส่วนเหลือด้วยตนเองที่เป็นผู้ชายที่อยู่ในระดับเดียวกันกับเขา
                        ซึ่งจะทำให้พวกเขากลับมารับมรดกในรูปแบบร่วมกันรับส่วนเหลือพร้อมกันกับผู้รับส่วนเหลือด้วยตนเองที่เป็นผู้ชายที่อยู่ในระดับเดียวกันกับเขา 
                        โดยแบ่งให้ฝ่ายผู้ชาย 2 ส่วนต่อฝ่ายหญิง 1 ส่วน และ <mark className=" bg-[#fee9b2] rounded-xl">ทายาทกลุ่มนี้คือผู้ที่รับมรดกอัตรา 1/2 หากมีคนเดียว และรับอัตรา 2/3 หากมีหลายคน </mark>{" "} ซึ่งมีดังนี้
                        <ul className=" list-disc ml-16 mt-3">
                          <li>ก. บุตรสาว</li>
                          <li>ข. หลานสาว (บุตรสาวของบุตรชายของผู้ตาย)</li>
                          <li>ค. พี่สาว หรือน้องสาวร่วมบิดามารดา</li>
                          <li>ง. พี่สาว หรือน้องสาวร่วมแต่บิดา</li>
                        </ul>
                    </li>
                    <li>
                      <b>ผู้รับส่วนเหลือพร้อมกับผู้อื่น (العصبة مع الغير) </b><br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง ทายาทฝ่ายผู้หญิงที่มีส่วนกำหนดแน่นอนอยู่แล้วในตอนแรก แต่เมื่อมีบุตรสาว หรือหลานสาว (บุตรสาวของบุตรชายของผู้ตาย)
                      หรือผู้สืบสันดานสายชายอื่น ๆ ที่เป็นหญิงอยู่ด้วย พวกนางก็จะรับส่วนเหลือทันที ซึ่งทายาทประเภทนี้แค่ 2 คน คือ
                      <ul className=" list-decimal ml-16 mt-3">
                        <li>พี่สาว หรือน้องสาวร่วมบิดามารดากับผู้ตาย</li>
                        <li>พี่สาว หรือน้องสาวร่วมแต่บิดา</li>
                      </ul>
                    </li> 
                  </ul>
              </p>
            </div>{/* จบ 3.2 อัลอะเศาะบะฮฺ อันนะสะบียะห์ */}

            {/* 3.3 อัลอะเศาะบะฮฺ อัสสะบาบียะห์ */}
            <div>
              <h3 id="seventhteen-header">3.3 อัลอะเศาะบะฮฺ อัสสะบาบียะห์ (العصبة السببية) </h3>
              <p className="ml-8">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; หมายถึง บุคคลที่มีความเป็นญาติกับผู้ตายโดยไม่ได้เป็นญาติทางสายเลือดกับผู้ตายโดยตรง เพียงแต่เพราะสาเหตุแห่งการไถ่ทาสให้เป็นไทเท่านั้น
              </p>
            </div>{/* จบ 3.3 อัลอะเศาะบะฮฺ อัสสะบาบียะห์ */}

            {/* 3.4 ซุลอัรฮาม */}
            <div>
              <h3 id="eighthteen-header">3.4 ซุลอัรฮาม (ذوي الأرحام) </h3>
              <p className="ml-8">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; หมายถึง ญาติของผู้ตายที่ไม่อยู่ในกลุ่มที่รับส่วนกำหนด (اصحاب الفروض) และไม่อยู่ในกลุ่มที่รับส่วนเหลือ (العصبة) 
                ซึ่งพวกเขาจะมีสิทธิได้รับมรดกของผู้ตายก็ต่อเมื่อไม่มีทายาททั้งสองกลุ่มที่ได้กล่าวถึงในข้างต้น
                <p className="ml-8">
                  <span className=" text-blue-600">
                    -- เช่น บรรดาบุตร (ทั้งชายและหญิง) ของบุตรหญิงของผู้ตาย, บรรดาบุตร (ทั้งชายและหญิง) ของบุตรสาวของบุตรชายของผู้ตาย, น้องชายของแม่ของผู้ตาย, น้องหญิงของแม่ของผู้ตาย, 
                    บุตรสาวของพี่สาว หรือน้องสาวของผู้ตาย  
                  </span>
                </p>
                <b>ซึ่งสามาถแยกทายาทภาคซุลอัรฮาม (ذوي الأرحام) </b>ดังต่อไปนี้
                <ul className=" list-decimal ml-16 mt-3">
                  <li>ตา</li>
                  <li>มารดาของตา หรือผู้หญิงของผู้สืบสันดานของมารดาของตาโดยตรงขึ้นไป</li>
                  <li>พี่น้องของมารดา</li>
                  <li>หลานที่เกิดจากบุตรสาว</li>
                  <li>เหลนที่เกิดจากหลานสาวที่เกิดจากบุตรชาย</li>
                  <li>หลานสาวที่เกิดจากพี่ชาย หรือน้องชายร่วมบิดามารดา และหลานที่เกิดจากพี่สาว หรือน้องสาวร่วมบิดามารดา</li>
                  <li>หลานสาวที่เกิดจากพี่ชาย หรือน้องชายร่วมแต่บิดา</li>
                  <li>หลานที่เกิดจากพี่สาว หรือน้องสาวร่วมแต่บิดา</li>
                  <li>หลานที่เกิดจากพี่น้องร่วมแต่มารดา</li>
                  <li>พี่ชาย หรือน้องชายของบิดาที่ร่วมแต่มารดา</li>
                  <li>พี่สาว หรือน้องสาวของบิดาที่ร่วมบิดามารดา หรือร่วมแต่บิดา หรือร่วมแต่มารดา</li>
                </ul>
                <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;โดยให้แบ่งมรดกแก่ทายาทประเภทนี้ตามเกณฑ์ของบุคคลผู้มีสิทธินั้น (บุคคลที่มีสิทธิในภาคฟัรฎู หรือภาคอะเศาะบะฮฺแบ่งส่วนให้ทายาทนั้นตามเกฑ์ของบุคคลผู้มีสิทธิ)
              </p>
            </div>{/*จบ 3.4 ซุลอัรฮาม */}
          </div>
        </div>

        {/* 4. การกันสิทธิ */}
        <div>
          <h2 id="nintennth-header">4. การกันสิทธิ</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การกันสิทธิ หมายถึง การกันสิทธิทายาทของผู้ตายยบางคนไม่ให้รับมรดกของผู้ตายเลย หรือให้ได้รับมรดกน้อยลง เนื่องจากมีบุคคลอื่นอยู่ 
            หรือการกีดกันผู้มีสิทธิที่จะได้รับมรดกไม่ให้ได้รับมรดกเลย หรือกีดกันไม่ให้ได้รับส่วนแบ่งที่มากที่สุดจากกองมรดก โดยการกันสิทธิถูกแบ่งออกเป็น 2 ลักษณะดังนี้
            <br></br>
              <ul className=" list-decimal ml-16 mb-3">
                <li>
                  <b>การกันสิทธิด้วยลักษณะบุคคล</b> หมายถึง การกีดกันบุคคลที่มีสาเหตุจะได้รับมรดกไม่ให้เขาได้รับมรดกเลย เพราะมีลักษณะเป็นบุคคลต้องห้ามในการรับมรดก โดยผู้ที่ถูกกันสิทธิลักษณะนี้เรียกว่า "มะฮฺรูม (المحروم) " ซึ่งลักษณะต่าง ๆ ที่ทำให้บุคคลกลายเป็นบุคคลต้องห้าม ได้แก่
                  <ul className=" list-disc ml-24 mb-3">
                    <li>การเป็นทาส</li>
                    <li>การเป็นฆาตกร</li>
                    <li>ต่างศาสนากับผู้ตาย</li>
                  </ul>      
                </li>
                <li>
                  <b>การกันสิทธิด้วยตัวบุคคล</b> หมายถึง การกันสิทธิบุคลลไม่ให้ได้รับมรดกเลย เรียกว่า "ฮีญับ ฮีรมาน (حجب حرمان)" <span className=" text-blue-600">-- เช่น บุตรชายของผู้ตาย -&gt; กันสิทธิหลานชายไม่ให้ได้รับมรดกเลย (กรณีที่มีชีวิตอยู่ทั้งสองคน), บิดากันสิทธิปู่ไม่ให้ได้รับมรดกเลยหากทั้งสองยังมีชีวิติยู่ </span>
                  หรือจะเป็นการกีดกันทายาทให้มีสิทธิได้รับมรดกน้อยลง หรือเปลี่ยนสิทธิของทายาทจากประเภทหนึ่งไปเป็นอีกประเภทหนึ่ง เรียกว่า "ฮีญับ นุกซอน (حجب نقصان)" <span className=" text-blue-600">-- เช่น บุตรของผู้ตาย (ภรรยา) จะกันสิทธิของสามีจาก 1/2 -&#62; 1/4, บุตรของผู้ตาย (สามี) จะกันสิทธิของภรรยาจาก 1/4 -&#62; 1/8 </span>
                  <br></br>
                  <h4 id="twelth-header">การกันสิทธิแบบ <mark className=" bg-[#fee9b2] rounded-xl">ฮีญับ นุกซอน (حجب نقصان)</mark></h4> 
                    <p className="ml-8">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;จะปรากฏเฉพาะในกรณีของทายาทประเภทอัศฮาบุลฟูรูฎ (اصحاب الفروض) หรือผู้รับมรดกแบบเศษส่วนที่มี 2 สภาพ จากส่วนรับที่มากที่สุดไปยังส่วนรับที่น้อยกว่าเท่านั้น ซึ่งมีอยู่ 5 คน
                      <ul className=" list-decimal ml-16 mb-3"> 
                        <li>สามี</li>
                        <li>ภรรยา</li>
                        <li>หลานสาว (บุตรสาวของบุตรชายของผู้ตาย)</li>
                        <li>พี่สาว หรือหน้องสาวร่วมแต่บิดากับผู้ตาย</li>
                        <li>มารดา</li>
                      </ul>
                    </p>
                  <h4 id="twelth-header">ตารางแสดงรายละเอียดของผู้กันสิทธิและเสียสิทธิแบบ<mark className=" bg-[#fee9b2] rounded-xl"> ฮีญับ ฮีรมาน (حجب حرمان)</mark>{" "}</h4>
                  <table className=" w-full mt-3">
                    {/* หัวข้อ */}
                    <tr>
                      <th>ลำดับที่</th>
                      <th>ผู้เสียสิทธิ</th>
                      <th>ผู้กันสิทธิ</th>
                    </tr>{" "}
                    <tr>
                      <td>1</td>
                      <td>บุตรชาย</td>
                      <td>-</td>
                    </tr>{" "}

                    <tr>
                      <td>2</td>
                      <td>บุตรสาว</td>
                      <td>-</td>
                    </tr>{" "}


                    <tr>
                      <td>3</td>
                      <td>บิดา</td>
                      <td>-</td>
                    </tr>{" "}

                    <tr>
                      <td>4</td>
                      <td>มารดา</td>
                      <td>-</td>
                    </tr>{" "}

                    <tr>
                      <td>5</td>
                      <td>สามี</td>
                      <td>-</td>
                    </tr>{" "}

                    <tr>
                      <td>6</td>
                      <td>ภรรยา</td>
                      <td>-</td>
                    </tr>{" "}

                    <tr>
                      <td>7</td>
                      <td>หลานชาย</td>
                      <td>บุตรชายของผู้ตาย</td>
                    </tr>{" "}

                    <tr>
                      <td>8</td>
                      <td>หลานสาว</td>
                      <td>บุตรชายของผู้ตาย, บุตรสาวของผู้ตายตั้งแต่สองคนขึ้นไป
                        ถ้าไม่มีหลานชายร่วมกับหลานสาวในการรับมรดก</td>
                    </tr>{" "}

                    <tr>
                      <td>9</td>
                      <td>ปู่</td>
                      <td>บิดาของผู้ตาย</td>
                    </tr>{" "}

                    <tr>
                      <td>10</td>
                      <td>ย่า</td>
                      <td>บิดาของผู้ตาย, มารดาของผู้ตาย</td>
                    </tr>{" "}

                    <tr>
                      <td>11</td>
                      <td>ยาย</td>
                      <td>มารดาของผู้ตาย</td>
                    </tr>{" "}

                    <tr>
                      <td>12</td>
                      <td>พี่ชาย หรือน้องชายร่วมบิดามารดา</td>
                      <td>บิดา, บุตรชาย, หลานชาย</td>
                    </tr>{" "}

                    <tr>
                      <td>13</td>
                      <td>พี่ชาย หรือน้องชายร่วมแต่บิดา</td>
                      <td>บิดา, บุตรชาย, พี่ชาย หรือน้องชายร่วมบิดามารดา, พี่สาว หรือน้องสาวร่วมบิดามารดาเมื่อนางรับมรดกส่วนเหลือร่วมกับผู้อื่น</td>
                    </tr>{" "}

                    <tr>
                      <td>14</td>
                      <td>พี่ชาย หรือน้องชายร่วมแต่มารดา</td>
                      <td>บิดา, ปู่, บุตรชาย, หลานชาย, บุตรสาว, หลานสาว</td>
                    </tr>{" "}

                    <tr>
                      <td>15</td>
                      <td>พี่สาว หรือน้องสาวร่วมบิดามารดา</td>
                      <td>บิดา, บุตรชาย, หลานชาย (บุตรชายของบุตรชายของผู้ตาย)</td>
                    </tr>{" "}

                    <tr>
                      <td>16</td>
                      <td>พี่สาว หรือน้องสาวร่วมบิดา</td>
                      <td>บิดา, บุตรชาย, หลานชาย, พี่ชาย หรือน้องชายร่วมบิดามารดา, พี่สาว หรือน้องสาวร่วมบิดามารดา</td>
                    </tr>{" "}

                    <tr>
                      <td>17</td>
                      <td>พี่สาว หรือน้องสาวร่วมแต่มารดา</td>
                      <td>บุตรชาย, หลานชาย, บุตรสาว, หลานสาว, บิดา, ปู่</td>
                    </tr>{" "}

                    <tr>
                      <td>18</td>
                      <td>บุตรชายของพี่ชาย หรือน้องชายร่วมบิดามารดาเดียวกัน</td>
                      <td>บิดา, ปู่, บุตรชาย, หลานชาย, พี่ชาย หรือน้องชายร่วมบิดามารดา, พี่ชาย หรือน้องชายร่วมแต่บิดา</td>
                    </tr>{" "}

                    <tr>
                      <td>19</td>
                      <td>บุตรชายของพี่ชาย หรือน้องชายร่วมแต่บิดา</td>
                      <td>บิดา, ปู่, บุตรชาย, หลานชาย, พี่ชาย หรือน้องชายร่วมบิดามารดา, พี่ชาย หรือน้องชายร่วมบิดา, บุตรชายของพี่ชาย หรือน้องชายร่วมบิดามารดา</td>
                    </tr>{" "}

                    <tr>
                      <td>20</td>
                      <td>ลุง, อา, บิดามารดาเดียวกันกับบิดาของผู็ตาย</td>
                      <td>บิดา, ปู่, บุตรชาย, หลานชาย, พี่น้องร่วมบิดามารดา, พี่น้องร่วมแต่บิดา, พี่สาว หรือน้องสาวร่วมบิดามารดา, พี่สาว หรือน้องสาวร่วมแต่บิดา, บุตรชายของพี่ชาย หรือน้องชายร่วมบิดามารดา</td>
                    </tr>{" "}
                  </table> 
                </li>
              </ul>
          </p>
        </div> {/* จบ 4. การกันสิทธิ */}
        <br></br>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
        <li>
            <a className="text-indigo-700 underline" href="/islam/1">
            ความรู้ทั่วไปของกฎหมายมรดกอิสลาม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/3">
            วิธีการคำนวณมรดกอิสลาม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/4">
              การแบ่งมรดกกรณีพิเศษ
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/5">
              บทบัญญัติที่ถูกกล่าวถึงในกฎหมายมรดก
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/6">
              พินัยกรรม
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ทายาทอิส;
